import { Routes, Route, Navigate } from 'react-router-dom';
import { LeadsDashboardPage } from './LeadsDashboardPage';
import { LeadsListPage } from './LeadsListPage';
import { LeadFollowupsPage } from './LeadFollowupsPage';
import { LeadsReportsPage } from './LeadsReportsPage';
import { LeadsPipelinePage } from './LeadsPipelinePage';
import { LeadsCalendarPage } from './LeadsCalendarPage';
import { LeadsTrashPage } from './LeadsTrashPage';
import { LeadsSettingsPage } from './LeadsSettingsPage';

/**
 * /leads/* — the Lead Management module.
 *
 * `/leads` lands on Manage Leads rather than the dashboard: the list is what the team works from
 * all day, and the dashboard is something they open on purpose.
 */
export function LeadsRoutes() {
  return (
    <Routes>
      <Route index element={<Navigate to="/leads/manage" replace />} />
      <Route path="dashboard" element={<LeadsDashboardPage />} />
      <Route path="manage" element={<LeadsListPage />} />
      <Route path="followups" element={<LeadFollowupsPage />} />
      <Route path="reports" element={<LeadsReportsPage />} />
      <Route path="pipeline" element={<LeadsPipelinePage />} />
      <Route path="calendar" element={<LeadsCalendarPage />} />
      <Route path="trash" element={<LeadsTrashPage />} />
      <Route path="settings" element={<LeadsSettingsPage />} />
      <Route path="*" element={<Navigate to="/leads/manage" replace />} />
    </Routes>
  );
}
